export default __webpack_public_path__ + "f021a673a0ab8240f5fdc1093d3084ff.png";